export default __webpack_public_path__ + "static/media/nyx.5dbe0dc0.jpg";